export class ContractsMeasures {
    measureId: number;
    measureName: string;
    totalPatients: number;
    completedMeasures: number;
    totalMet: string;
    exclusion: number;
    measureCompletion: number;
    performance: number;
    totalItems: number;
    contract: string;
}